//=============PATH=================//
import { apiBase, nodeApiBase } from "../config";
const SERVER_PATH = apiBase;
const NODE_SERVER_PATH = nodeApiBase;
export default class APIConstant {
  static path = {
    //Auth
    login: `${SERVER_PATH}/authentication/Login`,
    AppLogout: `${SERVER_PATH}/authentication/AppLogout`,
    AddUpdateUser: `${SERVER_PATH}/Auth.php?action=register`,
    SendOTPPhoneAndEmailAuth: `${SERVER_PATH}/authentication/SendOTPPhoneAndEmailAuth`,
    getUserListByAccountType: `${SERVER_PATH}/Auth.php?action=getUserListByAccountType`,
    getUserPlanByAccountAndUserType: `${SERVER_PATH}/Auth.php?action=getUserPlanByAccountAndUserType`,
    sendOTPOnCompanyID: `${SERVER_PATH}/Auth.php?action=sendOTPOnCompanyID`,
    ForgotPassword: `${SERVER_PATH}/Auth.php?action=ForgotPassword`,
    GetRedirectPath: `${SERVER_PATH}/authentication/GetRedirectPath`,
    verifyOTP: `${SERVER_PATH}/Auth.php?action=verifyOTP`,
    AddUpdateMemberUser: `${SERVER_PATH}/Auth.php?action=AddUpdateMemberUser`,

    // User
    GetUserPlanStatus: `${SERVER_PATH}/user/GetUserPlanStatus`,
    // Profile
    verifyAadhaar: `${SERVER_PATH}/profile/VerifyAadhaar`,
    verifyAadhaarOTP: `${SERVER_PATH}/profile/VerifyAadhaarOTP`,
    AddUpdateUserKyc: `${SERVER_PATH}/profile/AddUpdateUserKyc`,
    GetUserKyc: `${SERVER_PATH}/profile/GetUserKyc`,
    SendOTPPhoneAndEmail: `${SERVER_PATH}/profile/SendOTPPhoneAndEmail`,
    VerifyOTP: `${SERVER_PATH}/profile/VerifyOTP`,
    UpgradeUserPlan: `${SERVER_PATH}/Profile.php?action=UpgradeUserPlan`,
    UpgradeUserPlanFaildLogs: `${SERVER_PATH}/Profile.php?action=UpgradeUserPlanFaildLogs`,
    AddUpdateNetworkRequest: `${SERVER_PATH}/Profile.php?action=AddUpdateNetworkRequest`,
    // CHA API
    AddUpdateCHA: `${SERVER_PATH}/CHA.php?action=AddUpdateCHA`,

    // Handler Vessel request
    AddUpdateHandlerVesselRequest: `${SERVER_PATH}/HandlerVesselRequest.php?action=AddUpdateHandlerVesselRequest`,
    CancelDeleteHandlerVesselRequest: `${SERVER_PATH}/HandlerVesselRequest.php?action=CancelDeleteHandlerVesselRequest`,
    GetUnitName: `${SERVER_PATH}/HandlerVesselRequest.php?action=GetUnitName`,
    GetVesselDetail: `${SERVER_PATH}/HandlerVesselRequest.php?action=GetVesselDetail`,
    GetCommodityTypeList: `${SERVER_PATH}/HandlerVesselRequest.php?action=GetCommodityTypeList`,
    // Get Handler  vessel list API

    // Get Handler Dashboard  vessel list API
    GetHandlerVesselList: `${SERVER_PATH}/HandlerDashboard.php?action=GetHandlerVesselList`,
    GetHandlerVesselByID: `${SERVER_PATH}/HandlerDashboard.php?action=GetHandlerVesselByID`,
    GetSoldToPartyList: `${SERVER_PATH}/HandlerDashboard.php?action=GetSoldToPartyList`,
    GetSelectBEList: `${SERVER_PATH}/HandlerDashboard.php?action=GetSelectBEList`,
    GetSelectBEListByPartyID: `${SERVER_PATH}/HandlerDashboard.php?action=GetSelectBEListByPartyID`,

    AddUpdateHandlerImporterMaster: `${SERVER_PATH}/HandlerImporterMaster.php?action=AddUpdateHandlerImporterMaster`,
    GetUserListByType: `${SERVER_PATH}/HandlerImporterMaster.php?action=GetUserListByType`,
    GetHandlerImporterMaster: `${SERVER_PATH}/HandlerImporterMaster.php?action=GetHandlerImporterMaster`,
    AddLineShipperMaster: `${SERVER_PATH}/HandlerImporterMaster.php?action=AddLineShipperMaster`,

    //Stocks
    GetVesselDetailById: `${SERVER_PATH}/Stock.php?action=GetVesselDetailById`,
    AddUpdateMannualPurchaseEntry: `${SERVER_PATH}/Stock.php?action=AddUpdateMannualPurchaseEntry`,
    AddUpdateMannualSoldEntry: `${SERVER_PATH}/Stock.php?action=AddUpdateMannualSoldEntry`,
    AddUpdateStockDataOrder: `${SERVER_PATH}/Stock.php?action=AddUpdateStockDataOrder`,
    GetStockDataOrder: `${SERVER_PATH}/Stock.php?action=GetStockDataOrder`,

    //Network
    GenerateUniqueCustomerCode: `${SERVER_PATH}/network/GenerateUniqueCustomerCode`,
    AddUpdateNetwork: `${SERVER_PATH}/network/AddUpdateNetwork`,
    GetNetwork: `${SERVER_PATH}/network/GetNetwork`,
    GetNetworkByUserType: `${SERVER_PATH}/network/GetNetworkByUserType`,
    GetStaffList: `${SERVER_PATH}/network/GetStaffList`,
    GetNetworkById: `${SERVER_PATH}/network/GetNetworkById`,
    DeleteNetwork: `${SERVER_PATH}/network/DeleteNetwork`,
    UnlockStaff: `${SERVER_PATH}/network/UnlockStaff`,

    //new api structure
    GetFirstLastName: `${SERVER_PATH}/network/GetFirstLastName`,
    CreateNetwork: `${SERVER_PATH}/network/CreateNetwork`,
    GetMyNetwork: `${SERVER_PATH}/network/GetMyNetwork`,
    AddLoadingPerson: `${SERVER_PATH}/network/AddLoadingPerson`,
    GetLoadingPerson: `${SERVER_PATH}/network/GetLoadingPerson`,
    UpdateNetworkToggleStatus: `${SERVER_PATH}/network/UpdateNetworkToggleStatus`,

    //Common API
    getStringMap: `${SERVER_PATH}/Common.php?action=getStringMap`,
    getRoleTypeList: `${SERVER_PATH}/Common.php?action=getRoleTypeList`,
    getCompanyList: `${SERVER_PATH}/Common.php?action=getCompanyList`,

    // // Container
    // GetMasterCompanyName: `${SERVER_PATH}/Container.php?action=GetMasterCompanyName`,
    // AddMasterCompanyName: `${SERVER_PATH}/Container.php?action=AddMasterCompanyName`,
    // AddContainerType: `${SERVER_PATH}/Container.php?action=AddContainerType`,
    // GetContainerType: `${SERVER_PATH}/Container.php?action=GetContainerType`,
    // AddEditContainer: `${SERVER_PATH}/Container.php?action=AddEditContainer`,
    // DeleteContainerType: `${SERVER_PATH}/Container.php?action=DeleteContainerType`,
    // DeleteMasterCompany: `${SERVER_PATH}/Container.php?action=DeleteMasterCompany`,
    // GetMasterContainerList: `${SERVER_PATH}/Container.php?action=GetMasterContainerList`,
    // GetMasterContainerByID: `${SERVER_PATH}/Container.php?action=GetMasterContainerByID`,
    // GetSubContainerListByID: `${SERVER_PATH}/Container.php?action=GetSubContainerListByID`,
    // DeleteBLType: `${SERVER_PATH}/Container.php?action=DeleteBLType`,
    // GetBLType: `${SERVER_PATH}/Container.php?action=GetBLType`,
    // AddEditBLType: `${SERVER_PATH}/Container.php?action=AddEditBLType`,
    DeleteContainerJobStatus: `${SERVER_PATH}/Container.php?action=DeleteContainerJobStatus`,
    GetContainerJobStatus: `${SERVER_PATH}/Container.php?action=GetContainerJobStatus`,
    AddEditContainerJobStatus: `${SERVER_PATH}/Container.php?action=AddEditContainerJobStatus`,
    // AddEditCommodityType: `${SERVER_PATH}/Container.php?action=AddEditCommodityType`,
    // DeleteCommodityType: `${SERVER_PATH}/Container.php?action=DeleteCommodityType`,
    // GetComoditytType: `${SERVER_PATH}/Container.php?action=GetComoditytType`,
    // DeleteStuffingType: `${SERVER_PATH}/Container.php?action=DeleteStuffingType`,
    // GetStaffDashBoardList: `${SERVER_PATH}/Container.php?action=GetStaffDashBoardList`,
    // AddEditStuffingType: `${SERVER_PATH}/Container.php?action=AddEditStuffingType`,
    // GetContainerEditLogByID: `${SERVER_PATH}/Container.php?action=GetContainerEditLogByID`,
    // UpdateDateContainer: `${SERVER_PATH}/Container.php?action=UpdateDateContainer`,
    // GetContainerDashboard: `${SERVER_PATH}/Container.php?action=GetContainerDashboard`,
    // UpdateJobStatus: `${SERVER_PATH}/Container.php?action=UpdateJobStatus`,
    // DeleteContainer: `${SERVER_PATH}/Container.php?action=DeleteContainer`,
    ActiveInactiveJobStatus: `${SERVER_PATH}/Container.php?action=ActiveInactiveJobStatus`,
    // updateBLReleasedStatus: `${SERVER_PATH}/Container.php?action=updateBLReleasedStatus`,
    // GetJobStaffContainerList: `${SERVER_PATH}/Container.php?action=GetJobStaffContainerList`,
    // AddUpdateBLDraft: `${SERVER_PATH}/Container.php?action=AddUpdateBLDraft`,
    // GetBLDraftDataByID: `${SERVER_PATH}/Container.php?action=GetBLDraftDataByID`,
    // GetBLprintpdf: `${SERVER_PATH}/Container.php?action=GetBLprintpdf`,

    //User Management
    GetCompanyMembersList: `${SERVER_PATH}/UserManagement.php?action=GetCompanyMembersList`,
    GetCompanyMemberById: `${SERVER_PATH}/UserManagement.php?action=GetCompanyMemberById`,
    UpdateCompanyMember: `${SERVER_PATH}/UserManagement.php?action=UpdateCompanyMember`,
    GetContainerUserAccessList: `${SERVER_PATH}/UserManagement.php?action=GetContainerUserAccessList`,
    GetContainerRoleAccessList: `${SERVER_PATH}/UserManagement.php?action=GetContainerRoleAccessList`,
    UpdateCompanyRoleAccess: `${SERVER_PATH}/UserManagement.php?action=UpdateCompanyRoleAccess`,
    UpdateUserAccess: `${SERVER_PATH}/UserManagement.php?action=UpdateUserAccess`,
    GetRoleType: `${SERVER_PATH}/UserManagement.php?action=GetRoleType`,
    DeleteRoleType: `${SERVER_PATH}/UserManagement.php?action=DeleteRoleType`,
    AddRoleType: `${SERVER_PATH}/UserManagement.php?action=AddRoleType`,
    GetCompanyRole: `${SERVER_PATH}/UserManagement.php?action=GetCompanyRole`,
    UpdateShiftByUser: `${SERVER_PATH}/UserManagement.php?action=UpdateShiftByUser`,
    UpdateUserStatus: `${SERVER_PATH}/UserManagement.php?action=UpdateUserStatus`,

    // Quotation
    // AddUpdateQuotation: `${SERVER_PATH}/Quotation.php?action=AddUpdateQuotation`,
    // GetQuotationList: `${SERVER_PATH}/Quotation.php?action=GetQuotationList`,
    // GetQuotationByID: `${SERVER_PATH}/Quotation.php?action=GetQuotationByID`,
    // GetDutyStructureList: `${SERVER_PATH}/Quotation.php?action=GetDutyStructureList`,
    // DeleteQuotation: `${SERVER_PATH}/Quotation.php?action=DeleteQuotation`,

    // Master Api
    AddEditMasterByType: `${SERVER_PATH}/Master/AddEditMasterByType`,
    DeleteMasterByType: `${SERVER_PATH}/Master/DeleteMasterByType`,
    GetMasterListByType: `${SERVER_PATH}/Master/GetMasterListByType`,
    GetHSCodeList: `${SERVER_PATH}/Master.php?action=GetHSCodeList`,
    AddEditHSCode: `${SERVER_PATH}/Master.php?action=AddEditHSCode`,
    DeleteHSCode: `${SERVER_PATH}/Master.php?action=DeleteHSCode`,
    GetSearchHSCode: `${SERVER_PATH}/Master.php?action=GetSearchHSCode`,
    GetItemHSCodeSearchList: `${SERVER_PATH}/Master/GetItemHSCodeSearchList`,
    GetItemMasterList: `${SERVER_PATH}/Master/GetItemMasterList`,
    AddUpdateMasterItem: `${SERVER_PATH}/Master/AddUpdateMasterItem`,
    DeleteItemMaster: `${SERVER_PATH}/Master/DeleteItemMaster`,
    GetServiceMasterList: `${SERVER_PATH}/Master.php?action=GetServiceMasterList`,
    AddUpdateServiceMaster: `${SERVER_PATH}/Master.php?action=AddUpdateServiceMaster`,
    DeleteServiceMaster: `${SERVER_PATH}/Master.php?action=DeleteServiceMaster`,
    AddUpdateVesselMaster: `${SERVER_PATH}/Master.php?action=AddUpdateVesselMaster`,
    DeleteVesselMaster: `${SERVER_PATH}/Master.php?action=DeleteVesselMaster`,
    GetVesselMaster: `${SERVER_PATH}/Master.php?action=GetVesselMaster`,
    GetVesselMasterById: `${SERVER_PATH}/Master.php?action=GetVesselMasterById`,
    AddUpdateVesselStatus: `${SERVER_PATH}/Master.php?action=AddUpdateVesselStatus`,
    DeleteVesselStatus: `${SERVER_PATH}/Master.php?action=DeleteVesselStatus`,
    GetVesselStatusList: `${SERVER_PATH}/Master.php?action=GetVesselStatusList`,
    ActiveInactiveVesselStatus: `${SERVER_PATH}/Master.php?action=ActiveInactiveVesselStatus`,

    AddUpdatePanelMaster: `${SERVER_PATH}/Master.php?action=AddUpdatePanelMaster`,
    DeletePanelMaster: `${SERVER_PATH}/Master.php?action=DeletePanelMaster`,
    GetPanelMaster: `${SERVER_PATH}/Master.php?action=GetPanelMaster`,
    GetPanelMasterById: `${SERVER_PATH}/Master.php?action=GetPanelMasterById`,

    GetShiftFlagMaster: `${SERVER_PATH}/Master.php?action=GetShiftFlagMaster`,
    AddUpdateShiftFlagMaster: `${SERVER_PATH}/Master.php?action=AddUpdateShiftFlagMaster`,
    DeleteShiftFlagMaster: `${SERVER_PATH}/Master.php?action=DeleteShiftFlagMaster`,
    ActiveInactiveShiftFlag: `${SERVER_PATH}/Master.php?action=ActiveInactiveShiftFlag`,
    GetCargoTypeListByVesselName: `${SERVER_PATH}/Master.php?action=GetCargoTypeListByVesselName`,
    GetShiftMasterList: `${SERVER_PATH}/Master.php?action=GetShiftMasterList`,
    AddUpdateShiftMaster: `${SERVER_PATH}/Master.php?action=AddUpdateShiftMaster`,
    DeleteShiftMaster: `${SERVER_PATH}/Master.php?action=DeleteShiftMaster`,
    getShiftMasterListById: `${SERVER_PATH}/Master.php?action=getShiftMasterListById`,

    AddUpdatePortMaster: `${SERVER_PATH}/portmaster/AddUpdatePortMaster`,
    GetPortMaster: `${SERVER_PATH}/portmaster/GetPortMaster`,
    GetPortMasterByID: `${SERVER_PATH}/portmaster/GetPortMasterByID`,
    DeletePortMaster: `${SERVER_PATH}/portmaster/DeletePortMaster`,

    AddUpdateProductQuality: `${SERVER_PATH}/ProductQuality.php?action=AddUpdateProductQuality`,
    GetProductQuality: `${SERVER_PATH}/ProductQuality.php?action=GetProductQuality`,

    GetWtBridgeMasterList: `${SERVER_PATH}/WtBridge.php?action=GetWtBridgeMasterList`,
    AddEditWtBridgeMaster: `${SERVER_PATH}/WtBridge.php?action=AddEditWtBridgeMaster`,
    DeleteWtBridgeMaster: `${SERVER_PATH}/WtBridge.php?action=DeleteWtBridgeMaster`,
    GetWtBridgeMasterbyId: `${SERVER_PATH}/WtBridge.php?action=GetWtBridgeMasterbyId`,
    GetLocationList: `${SERVER_PATH}/WtBridge.php?action=GetLocationList`,

    AddUpdateLocationMaster: `${SERVER_PATH}/location/AddUpdateLocationMaster`,
    DeleteLocationMaster: `${SERVER_PATH}/location/DeleteLocationMaster`,
    GetLocationMasterByID: `${SERVER_PATH}/location/GetLocationMasterByID`,
    GetLocationMasterList: `${SERVER_PATH}/location/GetLocationMasterList`,
    GetLocationBySearchItem: `${SERVER_PATH}/location/GetLocationBySearchItem`,

    AddUpdatePersonalizedStatus: `${SERVER_PATH}/Order.php?action=AddUpdatePersonalizedStatus`,
    GetPersonalizedStatus: `${SERVER_PATH}/Order.php?action=GetPersonalizedStatus`,

    GenerateUniqueSKUId: `${SERVER_PATH}/item/GenerateUniqueSKUId`,
    AddUpdateDetailsVariantMaster: `${SERVER_PATH}/item/AddUpdateDetailsVariantMaster`,
    GetDetailsVariantMaster: `${SERVER_PATH}/item/GetDetailsVariantMaster`,
    GetDetailsVariantMasterById: `${SERVER_PATH}/item/GetDetailsVariantMasterById`,
    DeleteVariantDetailsMaster: `${SERVER_PATH}/item/DeleteVariantDetailsMaster`,
    GetVariantList: `${SERVER_PATH}/item/GetVariantList`,
    GetVariantListByType: `${SERVER_PATH}/item/GetVariantListByType`,
    GetLatestVariantRate: `${SERVER_PATH}/item/GetLatestVariantRate`,
    AddBatch: `${SERVER_PATH}/item/AddBatch`,
    GetVariantByBarcode: `${SERVER_PATH}/item/GetVariantByBarcode`,

    AddUpdateLoyaltyReward: `${SERVER_PATH}/loyalty/AddUpdateLoyaltyReward`,
    UpdateLoyaltyRewardDetails: `${SERVER_PATH}/loyalty/UpdateLoyaltyRewardDetails`,
    UpdateTierStatus: `${SERVER_PATH}/loyalty/UpdateTierStatus`,
    GetLoyaltyReward: `${SERVER_PATH}/loyalty/GetLoyaltyReward`,
    GetLoyaltyRewardById: `${SERVER_PATH}/loyalty/GetLoyaltyRewardById`,
    GetLoyaltyRewardDetailsById: `${SERVER_PATH}/loyalty/GetLoyaltyRewardDetailsById`,
    DeleteLoyaltyReward: `${SERVER_PATH}/loyalty/DeleteLoyaltyReward`,

    AddUpdateLoyaltyRedeem: `${SERVER_PATH}/loyalty/AddUpdateLoyaltyRedeem`,
    UpdateLoyaltyRedeemStatus: `${SERVER_PATH}/loyalty/UpdateLoyaltyRedeemStatus`,
    GetLoyaltyRedeem: `${SERVER_PATH}/loyalty/GetLoyaltyRedeem`,
    GetLoyaltyRedeemById: `${SERVER_PATH}/loyalty/GetLoyaltyRedeemById`,
    DeleteLoyaltyRedeem: `${SERVER_PATH}/loyalty/DeleteLoyaltyRedeem`,

    AddUpdateBerthMaster: `${SERVER_PATH}/BerthMaster.php?action=AddUpdateBerthMaster`,
    DeleteBerthMaster: `${SERVER_PATH}/BerthMaster.php?action=DeleteBerthMaster`,
    GetBerthMasterById: `${SERVER_PATH}/BerthMaster.php?action=GetBerthMasterById`,
    GetBerthMaster: `${SERVER_PATH}/BerthMaster.php?action=GetBerthMaster`,
    getJettyPostionList: `${SERVER_PATH}/BerthMaster.php?action=getJettyPostionList`,

    AddUpdateCategoryMaster: `${SERVER_PATH}/categorymaster/AddUpdateCategoryMaster`,
    DeleteCategoryMaster: `${SERVER_PATH}/categorymaster/DeleteCategoryMaster`,
    GetCategoryMasterById: `${SERVER_PATH}/categorymaster/GetCategoryMasterById`,
    GetCategoryMaster: `${SERVER_PATH}/categorymaster/GetCategoryMaster`,

    AddUpdateSubCategoryMaster: `${SERVER_PATH}/categorymaster/AddUpdateSubCategoryMaster`,
    DeleteSubCategoryMaster: `${SERVER_PATH}/categorymaster/DeleteSubCategoryMaster`,
    GetSubCategoryMasterById: `${SERVER_PATH}/categorymaster/GetSubCategoryMasterById`,
    GetSubCategoryMaster: `${SERVER_PATH}/categorymaster/GetSubCategoryMaster`,

    AddUpdateProductMaster: `${SERVER_PATH}/productmaster/AddUpdateProductMaster`,
    DeleteProductMaster: `${SERVER_PATH}/productmaster/DeleteProductMaster`,
    GetProductMasterById: `${SERVER_PATH}/productmaster/GetProductMasterById`,
    GetProductMaster: `${SERVER_PATH}/productmaster/GetProductMaster`,

    AddUpdateBrandMaster: `${SERVER_PATH}/brandmaster/AddUpdateBrandMaster`,
    DeleteBrandMaster: `${SERVER_PATH}/brandmaster/DeleteBrandMaster`,
    GetBrandMasterById: `${SERVER_PATH}/brandmaster/GetBrandMasterById`,
    GetBrandMaster: `${SERVER_PATH}/brandmaster/GetBrandMaster`,

    AddUpdateHSNCodeMaster: `${SERVER_PATH}/hsncode/AddUpdateHSNCodeMaster`,
    DeleteHSNCodeMaster: `${SERVER_PATH}/hsncode/DeleteHSNCodeMaster`,
    GetHSNCodeMasterById: `${SERVER_PATH}/hsncode/GetHSNCodeMasterById`,
    GetHSNCodeMaster: `${SERVER_PATH}/hsncode/GetHSNCodeMaster`,

    AddUpdateReasonMaster: `${SERVER_PATH}/ReasonMaster.php?action=AddUpdateReasonMaster`,
    DeleteReasonMaster: `${SERVER_PATH}/ReasonMaster.php?action=DeleteReasonMaster`,
    GetReasonMasterById: `${SERVER_PATH}/ReasonMaster.php?action=GetReasonMasterById`,
    GetReasonMaster: `${SERVER_PATH}/ReasonMaster.php?action=GetReasonMaster`,

    AddUpdateEquipmentMaster: `${SERVER_PATH}/Master/AddUpdateEquipmentMaster`,
    DeleteEquipmentMaster: `${SERVER_PATH}/Master/DeleteEquipmentMaster`,
    GetEquipmentMasterById: `${SERVER_PATH}/Master/GetEquipmentMasterById`,
    GetEquipmentMaster: `${SERVER_PATH}/Master/GetEquipmentMaster`,

    AddUpdateProcessMaster: `${SERVER_PATH}/ProcessMaster/AddUpdateProcessMaster`,
    DeleteProcessMaster: `${SERVER_PATH}/ProcessMaster/DeleteProcessMaster`,
    GetProcessMasterById: `${SERVER_PATH}/ProcessMaster/GetProcessMasterById`,
    GetProcessMaster: `${SERVER_PATH}/ProcessMaster/GetProcessMaster`,

    AddUpdateBranchMaster: `${SERVER_PATH}/branch/AddUpdateBranchMaster`,
    DeleteBranchMaster: `${SERVER_PATH}/branch/DeleteBranchMaster`,
    GetBranchMasterById: `${SERVER_PATH}/branch/GetBranchMasterById`,
    GetBranchMaster: `${SERVER_PATH}/branch/GetBranchMaster`,

    AddUpdateShipCard: `${SERVER_PATH}/ShipCard.php?action=AddUpdateShipCard`,
    GetShipCardList: `${SERVER_PATH}/ShipCard.php?action=GetShipCardList`,
    DeleteShipCard: `${SERVER_PATH}/ShipCard.php?action=DeleteShipCard`,
    GetShipCardDetailById: `${SERVER_PATH}/ShipCard.php?action=GetShipCardDetailById`,
    GetShipCardDashboardList: `${SERVER_PATH}/ShipCard.php?action=GetShipCardDashboardList`,
    GetShipCardLog: `${SERVER_PATH}/ShipCard.php?action=GetShipCardLog`,
    GetShipCardReport: `${SERVER_PATH}/ShipCard.php?action=GetShipCardReport`,
    GetVcnNoListByUserId: `${SERVER_PATH}/ShipCard.php?action=GetVcnNoListByUserId`,

    AddUpdateParticularMaster: `${SERVER_PATH}/Master.php?action=AddUpdateParticularMaster`,
    DeleteParticularMaster: `${SERVER_PATH}/Master.php?action=DeleteParticularMaster`,
    GetParticularMasterById: `${SERVER_PATH}/Master.php?action=GetParticularMasterById`,
    GetParticularMaster: `${SERVER_PATH}/Master.php?action=GetParticularMaster`,
    GetParticularMasterByRole: `${SERVER_PATH}/Master.php?action=GetParticularMasterByRole`,

    AddUpdateCountryMaster: `${SERVER_PATH}/Master/AddUpdateCountryMaster`,
    DeleteCountryMaster: `${SERVER_PATH}/Master/DeleteCountryMaster`,
    GetCountryMasterById: `${SERVER_PATH}/Master/GetCountryMasterById`,
    GetCountryMaster: `${SERVER_PATH}/Master/GetCountryMaster`,
    GetCountryNameByPort: `${SERVER_PATH}/Master/GetCountryNameByPort`,

    AddUpdateTerminalMaster: `${SERVER_PATH}/Master.php?action=AddUpdateTerminalMaster`,
    DeleteTerminalMaster: `${SERVER_PATH}/Master.php?action=DeleteTerminalMaster`,
    GetTerminalMasterById: `${SERVER_PATH}/Master.php?action=GetTerminalMasterById`,
    GetTerminalMaster: `${SERVER_PATH}/Master.php?action=GetTerminalMaster`,

    getUserAccessEquator: `${SERVER_PATH}/access/getUserAccessEquator`,
    getPageAccess: `${SERVER_PATH}/Access.php?action=getPageAccess`,
    getGlobalMasterAccess: `${SERVER_PATH}/Access.php?action=getGlobalMasterAccess`,

    GetShipCardReportByType: `${SERVER_PATH}/AdminNew.php?action=GetShipCardReportByType`,
    GetVCNNoList: `${SERVER_PATH}/AdminNew.php?action=GetVCNNoList`,
    UpdateVesselDeclarationStatus: `${SERVER_PATH}/AdminNew.php?action=UpdateVesselDeclarationStatus`,
    AddUpdateNotification: `${SERVER_PATH}/AdminNew.php?action=AddUpdateNotification`,
    GetVesselDeclarationById: `${SERVER_PATH}/AdminNew.php?action=GetVesselDeclarationById`,

    AddUpdateVesselDeclaration: `${SERVER_PATH}/VesselDeclaration.php?action=AddUpdateVesselDeclaration`,
    DeleteVesselDeclaration: `${SERVER_PATH}/VesselDeclaration.php?action=DeleteVesselDeclaration`,
    GetVesselDeclarationById: `${SERVER_PATH}/VesselDeclaration.php?action=GetVesselDeclarationById`,
    GetVesselDeclarationList: `${SERVER_PATH}/VesselDeclaration.php?action=GetVesselDeclarationList`,
    UpdateVesselDeclarationStatus: `${SERVER_PATH}/VesselDeclaration.php?action=UpdateVesselDeclarationStatus`,
    GetBerthingMeetingList: `${SERVER_PATH}/VesselDeclaration.php?action=GetBerthingMeetingList`,
    AddBerthMeetingSchedule: `${SERVER_PATH}/VesselDeclaration.php?action=AddBerthMeetingSchedule`,

    AddUpdateOperatorMaster: `${SERVER_PATH}/Master.php?action=AddUpdateOperatorMaster`,
    DeleteOperatorMaster: `${SERVER_PATH}/Master.php?action=DeleteOperatorMaster`,
    GetOperatorMasterById: `${SERVER_PATH}/Master.php?action=GetOperatorMasterById`,
    GetOperatorMaster: `${SERVER_PATH}/Master.php?action=GetOperatorMaster`,
    GetOperatorMasterbyLine: `${SERVER_PATH}/Master.php?action=GetOperatorMasterbyLine`,

    AddUpdateLineMaster: `${SERVER_PATH}/Master.php?action=AddUpdateLineMaster`,
    DeleteLineMaster: `${SERVER_PATH}/Master.php?action=DeleteLineMaster`,
    GetLineMasterById: `${SERVER_PATH}/Master.php?action=GetLineMasterById`,
    GetLineMaster: `${SERVER_PATH}/Master.php?action=GetLineMaster`,

    GetCISFTruckList: `${SERVER_PATH}/CISF.php?action=GetCISFTruckList`,
    UpdateCISFStatus: `${SERVER_PATH}/CISF.php?action=UpdateCISFStatus`,

    AddUpdateWaymentSlip: `${SERVER_PATH}/WaymentSlip.php?action=AddUpdateWaymentSlip`,
    DeleteWaymentSlip: `${SERVER_PATH}/WaymentSlip.php?action=DeleteWaymentSlip`,
    GetWaymentSlipbyId: `${SERVER_PATH}/WaymentSlip.php?action=GetWaymentSlipbyId`,
    GetWaymentSlipList: `${SERVER_PATH}/WaymentSlip.php?action=GetWaymentSlipList`,
    GetWaymentSlipByRSTNo: `${SERVER_PATH}/WaymentSlip.php?action=GetWaymentSlipByRSTNo`,
    GetWaymentSlipByWaymentNo: `${SERVER_PATH}/WaymentSlip.php?action=GetWaymentSlipByWaymentNo`,
    GetCOMPortByUserId: `${SERVER_PATH}/WaymentSlip.php?action=GetCOMPortByUserId`,
    GetPreviousData: `${SERVER_PATH}/WaymentSlip.php?action=GetPreviousData`,
    AddUpdateWaymentSlipReportAccess: `${SERVER_PATH}/WaymentSlip.php?action=AddUpdateWaymentSlipReportAccess`,
    GetWaymentSlipReportAccess: `${SERVER_PATH}/WaymentSlip.php?action=GetWaymentSlipReportAccess`,
    GetWaymentRateConfiguration: `${SERVER_PATH}/WaymentSlip.php?action=GetWaymentRateConfiguration`,
    AddUpdateWaymentRateConfiguration: `${SERVER_PATH}/WaymentSlip.php?action=AddUpdateWaymentRateConfiguration`,
    GetSlipRateConfigurationById: `${SERVER_PATH}/WaymentSlip.php?action=GetSlipRateConfigurationById`,
    GetWaymentRateAccess: `${SERVER_PATH}/WaymentSlip.php?action=GetWaymentRateAccess`,
    AddUpdateAddWaymentSlipConfig: `${SERVER_PATH}/WaymentSlip.php?action=AddUpdateAddWaymentSlipConfig`,
    GetAddWaymentSlipConfig: `${SERVER_PATH}/WaymentSlip.php?action=GetAddWaymentSlipConfig`,
    GetWaymentDashboard: `${SERVER_PATH}/WaymentSlip.php?action=GetWaymentDashboard`,
    GetSingleWaymentReport: `${SERVER_PATH}/WaymentSlip.php?action=GetSingleWaymentReport`,
    GetWaymentVehicleList: `${SERVER_PATH}/WaymentSlip.php?action=GetWaymentVehicleList`,
    GetWeighBridgeById: `${SERVER_PATH}/WaymentSlip.php?action=GetWeighBridgeById`,
    GetWBSlipReport: `${SERVER_PATH}/WaymentSlip.php?action=GetWBSlipReport`,
    GetTareWeightbyVehicleNo: `${SERVER_PATH}/WaymentSlip.php?action=GetTareWeightbyVehicleNo`,
    UpdateWaymentSlip: `${SERVER_PATH}/WaymentSlip.php?action=UpdateWaymentSlip`,
    CancelledWaymentSlip: `${SERVER_PATH}/WaymentSlip.php?action=CancelledWaymentSlip`,
    GetWaymentRstNo: `${SERVER_PATH}/WaymentSlip.php?action=GetWaymentRstNo`,

    AddUpdateVesselOperationStatus: `${SERVER_PATH}/VOS.php?action=AddUpdateVesselOperationStatus`,
    GetVesselOperationStatus: `${SERVER_PATH}/VOS.php?action=GetVesselOperationStatus`,
    DeleteVesselOperationStatus: `${SERVER_PATH}/VOS.php?action=DeleteVesselOperationStatus`,
    GetVesselOperationStatusById: `${SERVER_PATH}/VOS.php?action=GetVesselOperationStatusById`,

    // New API Structure Changes
    GetUserDetailsById: `${SERVER_PATH}/user/GetUserDetailsById`,
    GetEditUserDetails: `${SERVER_PATH}/user/GetEditUserDetails`,
    EditProfile: `${SERVER_PATH}/user/EditProfile`,
    GetPhoneEmail: `${SERVER_PATH}/user/GetPhoneEmail`,
    GetGSTVerifyData: `${SERVER_PATH}/user/GetGSTVerifyData`,
    GetPanVerifyData: `${SERVER_PATH}/user/GetPanVerifyData`,
    VerifyGST: `${SERVER_PATH}/user/VerifyGST`,
    VerifyPAN: `${SERVER_PATH}/user/VerifyPAN`,
    VerifyEmail: `${SERVER_PATH}/user/VerifyEmail`,
    SentGstAdminRequest: `${SERVER_PATH}/user/SentGstAdminRequest`,
    ChangeEmailPhone: `${SERVER_PATH}/user/ChangeEmailPhone`,
    VerifiedEmail: `${SERVER_PATH}/user/VerifiedEmail`,
    VerifiedPhone: `${SERVER_PATH}/user/VerifiedPhone`,
    GetRequestServicelist: `${SERVER_PATH}/user/GetRequestServicelist`,
    AddServiceNotification: `${SERVER_PATH}/user/AddServiceNotification`,
    GetOrganisationUsers: `${SERVER_PATH}/user/GetOrganisationUsers`,

    AddUpdateWareHouse: `${SERVER_PATH}/warehousemaster/AddUpdateWareHouse`,
    GetWareHouseById: `${SERVER_PATH}/warehousemaster/GetWareHouseById`,
    GetWareHouseList: `${SERVER_PATH}/warehousemaster/GetWareHouseList`,
    DeleteWareHouse: `${SERVER_PATH}/warehousemaster/DeleteWareHouse`,
    GetWareHouseDetailById: `${SERVER_PATH}/warehousemaster/GetWareHouseDetailById`,
    GetSubWareHouseList: `${SERVER_PATH}/warehousemaster/GetSubWareHouseList`,
    GetAddressTypeList: `${SERVER_PATH}/warehousemaster/GetAddressTypeList`,
    GetWarehouseListByUserId: `${SERVER_PATH}/warehousemaster/GetWarehouseListByUserId`,
    GetGodownNoList: `${SERVER_PATH}/warehousemaster/GetGodownNoList`,

    AddUpdateMakeMyLocation: `${SERVER_PATH}/MakeMyLocation.php?action=AddUpdateMakeMyLocation`,
    GetMyLocation: `${SERVER_PATH}/MakeMyLocation.php?action=GetMyLocation`,
    GetLoadingPersonPhoneEmail: `${SERVER_PATH}/MakeMyLocation.php?action=GetLoadingPersonPhoneEmail`,
    GetMyGroupList: `${SERVER_PATH}/MakeMyLocation.php?action=GetMyGroupList`,
    SaveLoadingPerson: `${SERVER_PATH}/MakeMyLocation.php?action=SaveLoadingPerson`,
    DeletePendingLocation: `${SERVER_PATH}/MakeMyLocation.php?action=DeletePendingLocation`,
    GetVesselByVesselId: `${SERVER_PATH}/MakeMyLocation.php?action=GetVesselByVesselId`,

    AddUpdateRoute: `${SERVER_PATH}/Route.php?action=AddUpdateRoute`,
    DeleteRoute: `${SERVER_PATH}/Route.php?action=DeleteRoute`,
    GetRoute: `${SERVER_PATH}/Route.php?action=GetRoute`,
    // Driver Api
    GetDriverList: `${SERVER_PATH}/Driver.php?action=GetDriverList`,
    searchLicenceDetails: `${SERVER_PATH}/Driver.php?action=searchLicenceDetails`,
    getTruckslist: `${SERVER_PATH}/Driver.php?action=getTruckslist`,
    getTruckRequest: `${SERVER_PATH}/Driver.php?action=getTruckRequest`,
    GetTripStatus: `${SERVER_PATH}/Driver.php?action=GetTripStatus`,
    AddUpdateTripManual: `${SERVER_PATH}/Driver.php?action=AddUpdateTripManual`,
    GetTransporter: `${SERVER_PATH}/Driver.php?action=GetTransporter`,
    GetTripMannualByID: `${SERVER_PATH}/Driver.php?action=GetTripMannualByID`,
    GetVehicleLiveStatus: `${SERVER_PATH}/Driver.php?action=GetVehicleLiveStatus`,
    sentTruckAdminRequest: `${SERVER_PATH}/Driver.php?action=sentTruckAdminRequest`,
    GetTransporterDashboard: `${SERVER_PATH}/Driver.php?action=GetTransporterDashboard`,
    AddUpdateDashboard: `${SERVER_PATH}/Driver.php?action=AddUpdateDashboard`,
    GetDashboard: `${SERVER_PATH}/Driver.php?action=GetDashboard`,
    GetTripMonthWise: `${SERVER_PATH}/Driver.php?action=GetTripMonthWise`,
    GetTransporterGraphDashboard: `${SERVER_PATH}/Driver.php?action=GetTransporterGraphDashboard`,
    GetUserList: `${SERVER_PATH}/Driver.php?action=GetUserList`,
    UpdateTruckStatus: `${SERVER_PATH}/Driver.php?action=UpdateTruckStatus`,
    AddUpdateSingleTrip: `${SERVER_PATH}/Driver.php?action=AddUpdateSingleTrip`,
    GetSingleTripById: `${SERVER_PATH}/Driver.php?action=GetSingleTripById`,
    GetTruckOrders: `${SERVER_PATH}/Driver.php?action=GetTruckOrders`,
    GetSingleTripReportById: `${SERVER_PATH}/Driver.php?action=GetSingleTripReportById`,
    GetMultiTripReportById: `${SERVER_PATH}/Driver.php?action=GetMultiTripReportById`,
    GetTripNo: `${SERVER_PATH}/Driver.php?action=GetTripNo`,
    GetSingleTripReport: `${SERVER_PATH}/Driver.php?action=GetSingleTripReport`,
    GetSingleTripReportFile: `${SERVER_PATH}/Driver.php?action=GetSingleTripReportFile`,

    AddUpdateTollPlaza: `${SERVER_PATH}/TollPlaza.php?action=AddUpdateTollPlaza`,
    GetTollPlazaList: `${SERVER_PATH}/TollPlaza.php?action=GetTollPlazaList`,
    DeleteTollPlaza: `${SERVER_PATH}/TollPlaza.php?action=DeleteTollPlaza`,
    GetTollPlazaById: `${SERVER_PATH}/TollPlaza.php?action=GetTollPlazaById`,

    GetTableDataOrder: `${SERVER_PATH}/TableDataOrder.php?action=GetTableDataOrder`,
    AddUpdateTableDataOrder: `${SERVER_PATH}/TableDataOrder.php?action=AddUpdateTableDataOrder`,

    getPageAccess: `${SERVER_PATH}/Access.php?action=getPageAccess`,
    getGlobalMasterAccess: `${SERVER_PATH}/Access.php?action=getGlobalMasterAccess`,

    GetMemberRoleForOwner: `${SERVER_PATH}/Auth.php?action=GetMemberRoleForOwner`,
    /* All Weigh Bridge API */
    GetAllWeighBridge: `${SERVER_PATH}/AllWeighBridge.php?action=GetAllWeighBridge`,
    AddUpdateAllWeighBridge: `${SERVER_PATH}/AllWeighBridge.php?action=AddUpdateAllWeighBridge`,
    DeleteAllWeighBridge: `${SERVER_PATH}/AllWeighBridge.php?action=DeleteAllWeighBridge`,
    GetWeighBridgeUserList: `${SERVER_PATH}/AllWeighBridge.php?action=GetWeighBridgeUserList`,
    CheckWeighOperatorExist: `${SERVER_PATH}/AllWeighBridge.php?action=CheckWeighOperatorExist`,

    GetMemberPlanList: `${SERVER_PATH}/Plan.php?action=GetMemberPlanList`,

    //Parking API
    GetParkingRateList: `${SERVER_PATH}/ParkingOperator.php?action=GetParkingRateList`,
    GetParkingRateByID: `${SERVER_PATH}/ParkingOperator.php?action=GetParkingRateByID`,
    AddUpdateParkingRate: `${SERVER_PATH}/ParkingOperator.php?action=AddUpdateParkingRate`,
    DeleteParkingRate: `${SERVER_PATH}/ParkingOperator.php?action=DeleteParkingRate`,

    // VehicleWhiteList API
    GetVehicleWhitelistList: `${SERVER_PATH}/VehicleWhitelist.php?action=GetVehicleWhitelistList`,
    GetVehicleWhitelistByID: `${SERVER_PATH}/VehicleWhitelist.php?action=GetVehicleWhitelistByID`,
    AddUpdateVehicleWhitelist: `${SERVER_PATH}/VehicleWhitelist.php?action=AddUpdateVehicleWhitelist`,
    DeleteVehicleWhitelist: `${SERVER_PATH}/VehicleWhitelist.php?action=DeleteVehicleWhitelist`,

    // All ParkingRate API
    GetAllParkingRate: `${SERVER_PATH}/AllParkingRate.php?action=GetAllParkingRate`,
    AddUpdateAllParkingRate: `${SERVER_PATH}/AllParkingRate.php?action=AddUpdateAllParkingRate`,
    DeleteAllParkingRate: `${SERVER_PATH}/AllParkingRate.php?action=DeleteAllParkingRate`,
    GetParkingRateUserList: `${SERVER_PATH}/AllParkingRate.php?action=GetParkingRateUserList`,
    CheckParkingOperatorExist: `${SERVER_PATH}/AllParkingRate.php?action=CheckParkingOperatorExist`,

    GetFixedRateMaster: `${SERVER_PATH}/Master.php?action=GetFixedRateMaster`,
    DeleteFixedRateMaster: `${SERVER_PATH}/Master.php?action=DeleteFixedRateMaster`,
    AddUpdateFixedRateMaster: `${SERVER_PATH}/Master.php?action=AddUpdateFixedRateMaster`,

    AddUpdateWBHelpCode: `${SERVER_PATH}/WBHelpCode.php?action=AddUpdateWBHelpCode`,
    GetWBHelpCode: `${SERVER_PATH}/WBHelpCode.php?action=GetWBHelpCode`,
    DeleteWBHelpCode: `${SERVER_PATH}/WBHelpCode.php?action=DeleteWBHelpCode`,
    GetWBHelpCodeById: `${SERVER_PATH}/WBHelpCode.php?action=GetWBHelpCodeById`,
    GetDataByWBHelpCode: `${SERVER_PATH}/WBHelpCode.php?action=GetDataByWBHelpCode`,

    ClearNotification: `${SERVER_PATH}/Notification.php?action=ClearNotification`,

    //Node API PAth

    generateUniqueJobNo: `${NODE_SERVER_PATH}/jobManagement/generateUniqueJobNo`,
    getJobManagement: `${NODE_SERVER_PATH}/jobManagement/getJobManagement`,
    getJobManagementById: `${NODE_SERVER_PATH}/jobManagement/getJobManagementById`,
    addUpdateJobManagement: `${NODE_SERVER_PATH}/jobManagement/addUpdateJobManagement`,
    deleteJobManagement: `${NODE_SERVER_PATH}/jobManagement/deleteJobManagement`,
    updateJobManagementStatus: `${NODE_SERVER_PATH}/jobManagement/updateJobManagementStatus`,

    getAttachmentMaster: `${NODE_SERVER_PATH}/master/getAttachmentMaster`,
    getAttachmentMasterById: `${NODE_SERVER_PATH}/master/getAttachmentMasterById`,
    addUpdateAttachmentMaster: `${NODE_SERVER_PATH}/master/addUpdateAttachmentMaster`,
    deleteAttachmentMaster: `${NODE_SERVER_PATH}/master/deleteAttachmentMaster`,
    GetTemplate: `${SERVER_PATH}/globalmaster/GetTemplate`,

    getCheckListMaster: `${NODE_SERVER_PATH}/master/getCheckListMaster`,
    getCheckListMasterById: `${NODE_SERVER_PATH}/master/getCheckListMasterById`,
    addUpdateCheckListMaster: `${NODE_SERVER_PATH}/master/addUpdateCheckListMaster`,
    deleteCheckListMaster: `${NODE_SERVER_PATH}/master/deleteCheckListMaster`,

    GetCompanyInitials: `${NODE_SERVER_PATH}/configuration/GetCompanyInitials`,
    GetCompanyInitialsById: `${NODE_SERVER_PATH}/configuration/GetCompanyInitialsById`,
    AddUpdateCompanyInitials: `${NODE_SERVER_PATH}/configuration/AddUpdateCompanyInitials`,
    DeleteCompanyInitials: `${NODE_SERVER_PATH}/configuration/DeleteCompanyInitials`,
    AddUpdateConfiguration: `${NODE_SERVER_PATH}/configuration/AddUpdateConfiguration`,
    GetConfigurationList: `${NODE_SERVER_PATH}/configuration/GetConfigurationList`,
    GetConfigurationById: `${NODE_SERVER_PATH}/configuration/GetConfigurationById`,
    DeleteConfiguration: `${NODE_SERVER_PATH}/configuration/DeleteConfiguration`,
    AddUpdateGeneralConfiguration: `${SERVER_PATH}/configuration/AddUpdateGeneralConfiguration`,
    GetGeneralConfiguration: `${SERVER_PATH}/configuration/GetGeneralConfiguration`,
    GetConfigurationByConfigurationName: `${SERVER_PATH}/configuration/GetConfigurationByConfigurationName`,
    AddUpdateAlertConfiguration: `${SERVER_PATH}/configuration/AddUpdateAlertConfiguration`,
    GetAlertConfiguration: `${SERVER_PATH}/configuration/GetAlertConfiguration`,
    DeleteAlertConfiguration: `${SERVER_PATH}/configuration/DeleteAlertConfiguration`,
    AddUpdateBarcodeConfiguration: `${SERVER_PATH}/configuration/AddUpdateBarcodeConfiguration`,
    GetBarcodeConfiguration: `${SERVER_PATH}/configuration/GetBarcodeConfiguration`,
    GetBarcodeConfigurationByConfigurationName: `${SERVER_PATH}/configuration/GetBarcodeConfigurationByConfigurationName`,
    DeleteBarcodeConfiguration: `${SERVER_PATH}/configuration/DeleteBarcodeConfiguration`,
    AddUpdatePOSBillConfiguration: `${SERVER_PATH}/configuration/AddUpdatePOSBillConfiguration`,
    GetPOSBillConfiguration: `${SERVER_PATH}/configuration/GetPOSBillConfiguration`,
    GetServicesList: `${SERVER_PATH}/configuration/GetServicesList`,
    GetBranchConfiguration: `${SERVER_PATH}/configuration/GetBranchConfiguration`,
    AddUpdateBranchConfiguration: `${SERVER_PATH}/configuration/AddUpdateBranchConfiguration`,
    GetRenderTemplate: `${SERVER_PATH}/configuration/GetRenderTemplate`,
    PrintBill: `${SERVER_PATH}/configuration/PrintBill`,

    getCompanyName: `${NODE_SERVER_PATH}/configuration/getCompanyName`,
    getCompanyNameById: `${NODE_SERVER_PATH}/configuration/getCompanyNameById`,
    addUpdateCompanyName: `${NODE_SERVER_PATH}/configuration/addUpdateCompanyName`,
    deleteCompanyName: `${NODE_SERVER_PATH}/configuration/deleteCompanyName`,

    searchLicenceDetails: `${NODE_SERVER_PATH}/ulipapi/searchLicenceDetails`,

    addUpdateDriver: `${NODE_SERVER_PATH}/driverapi/addUpdateDriver`,
    sentDriverAdminRequest: `${NODE_SERVER_PATH}/driverapi/sentDriverAdminRequest`,
    DeleteDriver: `${NODE_SERVER_PATH}/driverapi/DeleteDriver`,

    GenerateUniqueStockNo: `${SERVER_PATH}/stock/GenerateUniqueStockNo`,
    AddUpdateStock: `${SERVER_PATH}/stock/AddUpdateStock`,
    GetStockList: `${SERVER_PATH}/stock/GetStockList`,
    GetStockById: `${SERVER_PATH}/stock/GetStockById`,
    DeleteStock: `${SERVER_PATH}/stock/DeleteStock`,

    AddUpdateReminder: `${SERVER_PATH}/reminder/AddUpdateReminder`,
    GetReminderList: `${SERVER_PATH}/reminder/GetReminderList`,
    GetReminderById: `${SERVER_PATH}/reminder/GetReminderById`,
    DeleteReminder: `${SERVER_PATH}/reminder/DeleteReminder`,

    GetNotificationDetails: `${SERVER_PATH}/notification/GetNotificationDetails`,
    UpdateNewNotification: `${SERVER_PATH}/notification/UpdateNewNotification`,
    DeleteNotification: `${SERVER_PATH}/notification/DeleteNotification`,

    AddUpdateReasonMaster: `${SERVER_PATH}/reason/AddUpdateReasonMaster`,
    DeleteReasonMaster: `${SERVER_PATH}/reason/DeleteReasonMaster`,
    GetReasonMasterById: `${SERVER_PATH}/reason/GetReasonMasterById`,
    GetReasonMaster: `${SERVER_PATH}/reason/GetReasonMaster`,

    AddUpdatePaymentModeMaster: `${SERVER_PATH}/paymentmode/AddUpdatePaymentModeMaster`,
    DeletePaymentModeMaster: `${SERVER_PATH}/paymentmode/DeletePaymentModeMaster`,
    GetPaymentModeMasterById: `${SERVER_PATH}/paymentmode/GetPaymentModeMasterById`,
    GetPaymentModeMaster: `${SERVER_PATH}/paymentmode/GetPaymentModeMaster`,

    AddUpdateServiceCharges: `${SERVER_PATH}/servicecharge/AddUpdateServiceCharges`,
    DeleteServiceCharges: `${SERVER_PATH}/servicecharge/DeleteServiceCharges`,
    GetServiceChargesById: `${SERVER_PATH}/servicecharge/GetServiceChargesById`,
    GetServiceCharges: `${SERVER_PATH}/servicecharge/GetServiceCharges`,

    GenerateUniqueReturnId: `${SERVER_PATH}/stock/GenerateUniqueReturnId`,
    AddReturnedItems: `${SERVER_PATH}/stock/AddReturnedItems`,
    UpdateStockItems: `${SERVER_PATH}/stock/UpdateStockItems`,
    GenerateStockPDFBuffer: `${SERVER_PATH}/stock/GenerateStockPDFBuffer`,
    CalculatePriceBasedOnMode: `${SERVER_PATH}/stock/CalculatePriceBasedOnMode`,

    GetAuditOrderList: `${SERVER_PATH}/auditOrder/GetAuditOrderList `,
    FilterAuditOrderList: `${SERVER_PATH}/auditOrder/FilterAuditOrderList `,
    GenerateAuditNumber: `${SERVER_PATH}/auditOrder/GenerateAuditNumber`,
    GenerateOrderNumber: `${SERVER_PATH}/auditOrder/GenerateOrderNumber`,
    AddUpdateAuditItems: `${SERVER_PATH}/auditOrder/AddUpdateAuditItems`,
    GetAuditItems: `${SERVER_PATH}/auditOrder/GetAuditItems`,
    GetAuditItemsList: `${SERVER_PATH}/auditOrder/GetAuditItemsList`,
    CompareOrderData: `${SERVER_PATH}/auditOrder/CompareOrderData`,
    AddUpdateOrderItems: `${SERVER_PATH}/auditOrder/AddUpdateOrderItems`,
    GetOrderItems: `${SERVER_PATH}/auditOrder/GetOrderItems`,

    GetSubwarehouseItemList: `${SERVER_PATH}/master/GetSubwarehouseItemList`,

    GetPriceDifferenceReport: `${SERVER_PATH}/report/GetPriceDifferenceReport`,
    GetRegularityIrregularityReport: `${SERVER_PATH}/report/GetRegularityIrregularityReport`,
    GetSalesReport: `${SERVER_PATH}/report/GetSalesReport`,
    GenerateSalesReportExcel: `${SERVER_PATH}/report/GenerateSalesReportExcel`,
    AddUpdateScheduleReport: `${SERVER_PATH}/report/AddUpdateScheduleReport`,
    GetScheduleReportList: `${SERVER_PATH}/report/GetScheduleReportList`,
    GetScheduleReportById: `${SERVER_PATH}/report/GetScheduleReportById`,
    DeleteScheduleReport: `${SERVER_PATH}/report/DeleteScheduleReport`,

    GetSalesOverview: `${SERVER_PATH}/dashboard/GetSalesOverview`,
    GetBestSellingProducts: `${SERVER_PATH}/dashboard/GetBestSellingProducts`,

    AddUpdateUnitMaster: `${SERVER_PATH}/master/AddUpdateUnitMaster`,
    GetUnitMaster: `${SERVER_PATH}/master/GetUnitMaster`,
    GetUnitMasterById: `${SERVER_PATH}/master/GetUnitMasterById`,
    DeleteUnitMaster: `${SERVER_PATH}/master/DeleteUnitMaster`,

    AddUpdateUnitConfiguration: `${SERVER_PATH}/master/AddUpdateUnitConfiguration`,
    GetUnitConfiguration: `${SERVER_PATH}/master/GetUnitConfiguration`,
    GetUnitConfigurationById: `${SERVER_PATH}/master/GetUnitConfigurationById`,
    DeleteUnitConfiguration: `${SERVER_PATH}/master/DeleteUnitConfiguration`,

    AddUpdateInsuranceCompany: `${SERVER_PATH}/warehousemaster/AddUpdateInsuranceCompany`,
    GetInsuranceCompanyMaster: `${SERVER_PATH}/warehousemaster/GetInsuranceCompanyMaster`,

    // Inward
    AddUpdateInward: `${SERVER_PATH}/inventory/AddUpdateInward`,
    GetInward: `${SERVER_PATH}/inventory/GetInward`,
    GetInwardById: `${SERVER_PATH}/inventory/GetInwardById`,
    DeleteInward: `${SERVER_PATH}/inventory/DeleteInward`,
    GenerateInwardPdf: `${SERVER_PATH}/inventory/GenerateInwardPdf`,
    CheckUnitConversion: `${SERVER_PATH}/inventory/CheckUnitConversion`,
    AddUpdateManufacturing: `${SERVER_PATH}/inventory/AddUpdateManufacturing`,
    GetManufacturing: `${SERVER_PATH}/inventory/GetManufacturing`,
    GetManufacturingById: `${SERVER_PATH}/inventory/GetManufacturingById`,
    DeleteManufacturing: `${SERVER_PATH}/inventory/DeleteManufacturing`,

    AddUpdateDataOrder: `${SERVER_PATH}/common/AddUpdateDataOrder`,
    GetDataOrder: `${SERVER_PATH}/common/GetDataOrder`,
    AddUpdateAccountConfiguration: `${SERVER_PATH}/common/AddUpdateAccountConfiguration`,
    GetAccountConfiguration: `${SERVER_PATH}/common/GetAccountConfiguration`,

    GetAuditOrderList: `${SERVER_PATH}/auditOrder/GetAuditOrderList `,
    FilterAuditOrderList: `${SERVER_PATH}/auditOrder/FilterAuditOrderList `,
    GenerateAuditNumber: `${SERVER_PATH}/auditOrder/GenerateAuditNumber`,
    GenerateOrderNumber: `${SERVER_PATH}/auditOrder/GenerateOrderNumber`,
    AddUpdateAuditItems: `${SERVER_PATH}/auditOrder/AddUpdateAuditItems`,
    GetAuditItems: `${SERVER_PATH}/auditOrder/GetAuditItems`,
    GetAuditItemsList: `${SERVER_PATH}/auditOrder/GetAuditItemsList`,
    CompareOrderData: `${SERVER_PATH}/auditOrder/CompareOrderData`,
    AddUpdateOrderItems: `${SERVER_PATH}/auditOrder/AddUpdateOrderItems`,
    GetOrderItems: `${SERVER_PATH}/auditOrder/GetOrderItems`,

    //POS
    AddUpdatePOS: `${SERVER_PATH}/pos/AddUpdatePOS`,
    GetLatestInvoiceData: `${SERVER_PATH}/pos/GetLatestInvoiceData`,
    GetLatestInvoiceList: `${SERVER_PATH}/pos/GetLatestInvoiceList`,
    GetRecentItemList: `${SERVER_PATH}/pos/GetRecentItemList`,
    AddPinnedItems: `${SERVER_PATH}/pos/AddPinnedItems`,
    GetPinnedItems: `${SERVER_PATH}/pos/GetPinnedItems`,
    DeletePOS: `${SERVER_PATH}/pos/DeletePOS`,
    GetPOSList: `${SERVER_PATH}/pos/GetPOSList`,
    GetPOSById: `${SERVER_PATH}/pos/GetPOSById`,

    //Company Master
    AddUpdateCompanyMaster: `${SERVER_PATH}/companymaster/AddUpdateCompanyMaster`,
    GetCompanyMaster: `${SERVER_PATH}/companymaster/GetCompanyMaster`,
    DeleteCompanyMaster: `${SERVER_PATH}/companymaster/DeleteCompanyMaster`,
    GetAdminCompanyMasterById: `${SERVER_PATH}/companymaster/GetAdminCompanyMasterById`,

    AddUpdateImageConfiguration: `${SERVER_PATH}/configuration/AddUpdateImageConfiguration`,
    GetImageConfiguration: `${SERVER_PATH}/configuration/GetImageConfiguration`,

    AddUpdateOutward: `${SERVER_PATH}/outward/AddUpdateOutward`,
    GetOutward: `${SERVER_PATH}/outward/GetOutward`,
    GetOutwardById: `${SERVER_PATH}/outward/GetOutwardById`,
    DeleteOutward: `${SERVER_PATH}/outward/DeleteOutward`,
    GenerateOutwardPdf: `${SERVER_PATH}/outward/GenerateOutwardPdf`,
    AddUpdatePerformaInvoice: `${SERVER_PATH}/outward/AddUpdatePerformaInvoice`,
    GetPerformaInvoice: `${SERVER_PATH}/outward/GetPerformaInvoice`,
    GetPerformaInvoiceById: `${SERVER_PATH}/outward/GetPerformaInvoiceById`,
    DeletePerformaInvoice: `${SERVER_PATH}/outward/DeletePerformaInvoice`,
    GenerateUniquePerformaInvoiceNo: `${SERVER_PATH}/outward/GenerateUniquePerformaInvoiceNo`,
    AddUpdateSalesOrder: `${SERVER_PATH}/outward/AddUpdateSalesOrder`,
    GetSalesOrder: `${SERVER_PATH}/outward/GetSalesOrder`,
    GetSalesOrderById: `${SERVER_PATH}/outward/GetSalesOrderById`,
    DeleteSalesOrder: `${SERVER_PATH}/outward/DeleteSalesOrder`,
    GenerateUniqueSalesOrderNo: `${SERVER_PATH}/outward/GenerateUniqueSalesOrderNo`,
    AddUpdateTransferOutward: `${SERVER_PATH}/outward/AddUpdateTransferOutward`,
  };
}
